var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard Copy 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter-tool-black-shape-(3)",
    transform: "translate(20.000000, 20.000000) scale(-1, 1) translate(-20.000000, -20.000000) translate(8.000000, 8.000000)",
    fill: "#535453",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.897488,0.664845744 C23.704273,0.221794355 23.3698878,0.000238809534 22.8927226,0 L1.10671077,0 C0.630201376,0 0.295339214,0.221794355 0.102422362,0.664845744 C-0.0903752582,1.13058404 -0.0110265778,1.52856013 0.340826098,1.85799788 L8.73217261,10.2612875 L8.73217261,18.5452917 C8.73217261,18.841117 8.84001766,19.0964641 9.05552892,19.3127062 L13.4125524,23.6759355 C13.6169751,23.8916999 13.8721906,24 14.1786756,24 C14.3147189,24 14.4564854,23.9714026 14.6040346,23.9146256 C15.0467418,23.7213093 15.268155,23.3861998 15.268155,22.9089389 L15.268155,10.2613472 L23.6592034,1.85805758 C24.0111754,1.52861983 24.0903452,1.13076315 23.897488,0.664845744 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.c4448b02bd7f1de6bf0713cbb4766d0e.svg";
export { ForwardRef as ReactComponent };